<template>
    <b-form-row>
        <b-modal button-size="sm" hide-footer size="xl" :title="prefix + title" v-model="showModal" @hidden="cancelar">

            <span class="ml-3">Exercícío atual: {{ this.anoAtual }}</span>

            <b-form v-if="mostrarTela">
                <b-col cols="12">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>

                                <LgFinderPagePessoa :comecaComissao="isComissao" :mostrarComissao="true"
                                    :labelComissao="'Comissão:*'" id="finderResponsavelModalInventarioItemBemConsumo"
                                    v-model="pessoaComissao" :prefix="prefix + title + ' > '"
                                    @onselectComissao="handleSelectComissao" @onselect="handleSelectResponsavel"
                                    label="Responsável:*" invalid-feedback="Informe uma pessoa!" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <div class="d-flex justify-content-end">

                    <b-button id="adicionar" class="ml-3 mr-4" size="sm" style="height: 60px" pill variant="primary"
                        @click="abrirModalAlmoxarifado">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="plus" />
                        </div>
                        <b-tooltip target="adicionar" title="Adicionar novo almoxarifado..."></b-tooltip>

                    </b-button>
                </div>

                <b-table :items="form.almoxarifados" :fields="itemsTableFields" :busy="busy" show-empty>


                    <template #empty>
                        <p class="text-center">Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle" />
                        </div>
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button :id="row.index + 'excluirAlmoxarifado'" class=" my-2" size="sm" pill variant="primary"
                            @click="removeAlmoxarife(row.item)">
                            <b-icon icon="trash-fill" />
                            <b-tooltip :target="row.index + 'excluirAlmoxarifado'" title="Remover..."></b-tooltip>

                        </b-button>
                    </template>

                </b-table>
                <b-form-row>

                    <b-col cols="3"></b-col>
                    <b-col cols="6" class="text-center">
                        <b-button id="salvarInventarioConserv" class=" my-2" size="sm" pill variant="success"
                            @click="save">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="salvarInventarioConserv" title="Salvar"></b-tooltip>

                        </b-button>

                        <b-button id="cancelarInventarioConserv" class=" my-2 ml-2" size="sm" pill variant="danger"
                            @click="cancelar">
                            <b-icon icon="x-circle" />
                            <b-tooltip target="cancelarInventarioConserv" title="Cancelar"></b-tooltip>

                        </b-button>
                    </b-col>
                    <b-col cols="3"></b-col>

                </b-form-row>

            </b-form>

        </b-modal>
        <LgFinderPageAlmoxarifadoModal :departamento="departamento" v-if="modalSelecionarAlmoxarifado"
            @close="fecharModalSelecionarAlmoxarifado" @onSelect="selecionarAlmoxarifado"
            :prefix="prefix + title + ' > '">
        </LgFinderPageAlmoxarifadoModal>
    </b-form-row>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import ResourceService from "@/core/api/ResourceService"
import LgFinderPageAlmoxarifadoModal from "@/components/Modal/LgFinderPageAlmoxarifadoModal.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import { FormResourceMixin } from "@/core/mixins/resource";


export default {
    name: "InventarioItemBemConsumoForm",
    components: {
        LgFinderPagePessoa,
        LgFinderPageAlmoxarifadoModal
    },
    mixins: [ConfirmMixin, FormResourceMixin],
    props: {
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Cadastro"
        },
        id: Number,

    },

    data() {
        return {
            isComissao: false,
            departamento: {},
            pessoaComissao: null,
            modalSelecionarAlmoxarifado: false,
            mostrarTela: false,
            anoAtual: "",
            showModal: true,
            form: {
                almoxarifadosParaRemover: [],
                almoxarifadosParaAdicionar: [],
                id: null,
                pessoa: null,
                comissao: null,
                almoxarifados: []
            },
            itemsTableFields: [
                { key: "descricao", label: "Descrição" },
                { key: 'action', label: '', }

            ],
            busy: false,
            page: 0,
            size: 20,
        };
    },
    methods: {

        async removeAlmoxarife(almoxarifado) {

            let response = await this.$confirm(
                "Confirmação",
                "Tem certeza que deseja remover a vinculação?"
            );

            if (response) {

                const index = this.form.almoxarifados.findIndex(item => item.id === almoxarifado.id);
                var itemParaRemover = this.form.almoxarifados.splice(index, 1)[0];

                if (this.id) {
                    this.form.almoxarifadosParaRemover.push(itemParaRemover.id);

                    const indexParaRemover = this.form.almoxarifadosParaAdicionar.findIndex(item => item.id === almoxarifado.id);

                    if (indexParaRemover !== -1)
                        this.form.almoxarifadosParaAdicionar.splice(indexParaRemover, 1);
                }
            }
        },

        selecionarAlmoxarifado(almoxarifado) {

            const found = this.form.almoxarifados.find(
                item => item.id === almoxarifado.id
            );

            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Almoxarifado já vinculado!",
                });
                return;
            }

            this.form.almoxarifados.push(almoxarifado);
            if (this.id)
                this.form.almoxarifadosParaAdicionar.push(almoxarifado);

            this.modalSelecionarAlmoxarifado = false;
        },
        abrirModalAlmoxarifado() {
            this.modalSelecionarAlmoxarifado = true;
        },
        fecharModalSelecionarAlmoxarifado() {
            this.modalSelecionarAlmoxarifado = false;
        },
        cancelar() {
            this.$emit("close");
        },

        async save() {

            if (!this.pessoaComissao || !this.pessoaComissao.id) {
                this.$notify({
                    type: "danger",
                    message: `É necessário informar a Pessoa ou a Comissão`,
                });
                return;
            }

            if (!this.form.almoxarifados || this.form.almoxarifados.length === 0) {
                this.$notify({
                    type: "danger",
                    message: `É necessário informar ao menos um Almoxarifado`,
                });
                return;
            }

            try {

                await this.$saveResource(this.form, "", false, {}, false, true);
                this.cancelar();
            }
            catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.data,
                });
            }


        },
        handleSelectResponsavel(responsavel) {
            this.form.pessoa = responsavel;
            this.pessoaComissao = responsavel;

            this.form.comissao = {};


        },
        handleSelectComissao(comissao) {
            this.pessoaComissao = comissao;
            this.form.comissao = comissao;

            this.form.pessoa = {};

        },
    },

    async beforeMount() {

        this.$service = new ResourceService("/api/inventario-ibc");
        this.$serviceExercicio = new ResourceService("/api/exercicio-fiscal");
        const brand = JSON.parse(localStorage.getItem("context"));
        this.departamento = brand.departamento;

        if (this.id) {
            this.busy = true;
            var { data } = await this.$service.findById(this.id);
            this.form = data;

            this.form.almoxarifadosParaAdicionar = [];
            this.form.almoxarifadosParaRemover = [];

            if (this.form.pessoa && this.form.pessoa.id) {
                this.pessoaComissao = this.form.pessoa
            }
            else {
                this.isComissao = true;
                this.pessoaComissao = this.form.comissao;

            }
            this.anoAtual = this.form.ano;
            this.busy = false;
            this.mostrarTela = true;
            return;
        }


        try {
            this.anoAtual = (await this.$serviceExercicio.get("atual-ano")).data;
            this.mostrarTela = true;
        }
        catch (error) {
            this.$notify({
                type: "danger",
                message: error.response.data,
            });
            this.anoAtual = error.response.data;
        }


    },
};
</script>